/* Colorama landing — behaviour for sections/colorama.liquid */
(function () {
  'use strict';
  if (window.ColoramaLP) return;

  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DESKTOP = window.matchMedia('(min-width: 1100px)');
  var EMAIL_RE = /^[^@\s]+@[^@\s]+\.[a-z]{2,}$/i;
  var KLAVIYO_ENDPOINT = 'https://a.klaviyo.com/client/subscriptions?company_id=';
  var META_PIXEL_SRC = 'https://connect.facebook.net/en_US/fbevents.js';
  var ARTBOARD_MOBILE = 428;
  var ARTBOARD_DESKTOP = 1920;
  var HERO_DELAY_MS = 120;
  var HERO_FALLBACK_MS = 1500;
  var PARALLAX_MAX = 1600;
  var PARALLAX_RATE = 0.06;
  var MODAL_FOCUS_DELAY_MS = 350;
  var MODAL_CLOSE_MS = 320;
  var SIGNUP_OFFSET = 0.12;
  var states = new WeakMap();
  var metaPixelsReady = {};

  function $$(selector, scope) { return Array.prototype.slice.call(scope.querySelectorAll(selector)); }
  function fontsReady() { return document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve(); }
  function on(target, type, handler, signal, options) {
    var opts = options || {};
    opts.signal = signal;
    target.addEventListener(type, handler, opts);
  }
  function isDesignMode() { return !!(window.Shopify && window.Shopify.designMode); }

  /* ---------- progress ---------- */
  function initProgress(root, signal) {
    var bar = root.querySelector('[data-cl-progress]');
    if (!bar) return;
    function paint() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      var p = h > 0 ? Math.min(Math.max(window.scrollY / h, 0), 1) : 0;
      bar.style.transform = 'scaleX(' + p + ')';
    }
    on(window, 'scroll', paint, signal, { passive: true });
    on(window, 'resize', paint, signal);
    paint();
  }

  /* ---------- baseline lock: every text sits on its XD baseline, whatever font metrics load ---------- */
  function lockBaselines(root) {
    var stage = root.querySelector('.cl-stage');
    if (!stage) return;
    var desktop = DESKTOP.matches;
    var u = stage.getBoundingClientRect().width / (desktop ? ARTBOARD_DESKTOP : ARTBOARD_MOBILE);
    $$('[data-bl]', root).forEach(function (el) {
      var offset = parseFloat(desktop ? el.dataset.bl : el.dataset.blm);
      if (isNaN(offset)) return;
      var marker = el.querySelector(':scope > .cl-blm');
      if (!marker) {
        marker = document.createElement('i');
        marker.className = 'cl-blm';
        marker.setAttribute('aria-hidden', 'true');
        el.insertBefore(marker, el.firstChild);
      }
      el.style.top = '0px';
      var actual = marker.getBoundingClientRect().bottom - el.getBoundingClientRect().top;
      el.style.top = (offset * u - actual).toFixed(2) + 'px';
    });
  }

  /* ---------- reveal ---------- */
  function initReveal(root, signal) {
    $$('[data-d]', root).forEach(function (n) { n.style.setProperty('--d', n.dataset.d + 'ms'); });
    var targets = $$('[data-cl-reveal], .cl-split, .cl-clipimg', root);
    var heroes = $$('[data-cl-hero]', root);
    function show(n) { n.classList.add('is-in'); }
    if (RM || isDesignMode()) { targets.concat(heroes).forEach(show); return; }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { show(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    targets.forEach(function (n) { if (!n.hasAttribute('data-cl-hero')) io.observe(n); });
    signal.addEventListener('abort', function () { io.disconnect(); });

    /* whatever sits at the very bottom still plays in */
    on(window, 'scroll', function () {
      if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 4) {
        $$('[data-cl-reveal]:not(.is-in), .cl-split:not(.is-in)', root).forEach(show);
      }
    }, signal, { passive: true });

    /* the hero plays in once the script face is ready */
    var heroGo = function () { heroes.forEach(show); };
    fontsReady().then(function () { setTimeout(heroGo, HERO_DELAY_MS); });
    setTimeout(heroGo, HERO_FALLBACK_MS);
  }

  /* ---------- header parallax (scroll) ---------- */
  function initParallax(root, signal) {
    var img = root.querySelector('.cl-hero__art img');
    if (!img || RM) return;
    var ticking = false;
    on(window, 'scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = Math.min(window.scrollY, PARALLAX_MAX);
        img.style.translate = '0 ' + (-y * PARALLAX_RATE) + 'px';
        ticking = false;
      });
    }, signal, { passive: true });
  }

  /* ---------- the film: plays only when you click it ---------- */
  function filmSource(slot) {
    var desktop = slot.getAttribute('data-src');
    var mobile = slot.getAttribute('data-src-mobile');
    return DESKTOP.matches ? (desktop || mobile) : (mobile || desktop);
  }

  function wireFilm(slot, signal) {
    var btn = slot.querySelector('.cl-playbtn');
    var still = slot.querySelector('img');
    var vid = null;
    function teardown() {
      slot.classList.remove('is-playing', 'is-loading');
      if (vid) { vid.remove(); vid = null; }
    }
    function start() {
      if (vid) {
        var resumed = vid.play();
        if (resumed && resumed.catch) resumed.catch(function () { slot.classList.remove('is-loading'); });
        return;
      }
      vid = document.createElement('video');
      vid.className = 'cl-filmplayer';
      vid.src = filmSource(slot);
      if (still) vid.poster = still.currentSrc || still.src;
      vid.preload = 'auto';
      vid.playsInline = true;
      vid.setAttribute('playsinline', '');
      vid.controls = true;
      slot.appendChild(vid);
      slot.classList.add('is-loading', 'is-playing');
      vid.addEventListener('playing', function () { slot.classList.remove('is-loading'); });
      vid.addEventListener('ended', function () { teardown(); if (btn) btn.focus({ preventScroll: true }); });
      vid.addEventListener('error', function () { console.error('[colorama] film failed to load:', filmSource(slot)); teardown(); });
      var started = vid.play();
      if (started && started.catch) started.catch(function () { slot.classList.remove('is-loading'); });
    }
    if (btn) btn.addEventListener('click', function (e) { e.stopPropagation(); start(); });
    slot.addEventListener('click', function (e) { if (!vid && e.target !== btn) start(); });
    /* scrolled away: pause (no autoplay when coming back) */
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (!e.isIntersecting && vid && !vid.paused) vid.pause(); });
    }, { threshold: 0.2 });
    io.observe(slot);
    signal.addEventListener('abort', function () { io.disconnect(); });
  }

  /* ---------- forms (page + popup): Klaviyo list, or Shopify customer ---------- */
  function klaviyoCompanyId(root) {
    var id = root.getAttribute('data-klaviyo-key');
    if (id) return id;
    var script = document.querySelector('script[src*="klaviyo.com/onsite/js/"]');
    var match = script && (script.src.match(/company_id=([A-Za-z0-9]+)/) || script.src.match(/onsite\/js\/([A-Za-z0-9]+)\/klaviyo/));
    return match ? match[1] : '';
  }

  function subscribeToKlaviyo(root, email) {
    var company = klaviyoCompanyId(root);
    if (!company) return Promise.reject(new Error('No Klaviyo public API key set and no Klaviyo onsite script found'));
    var attributes = { profile: { data: { type: 'profile', attributes: { email: email } } } };
    var source = root.getAttribute('data-klaviyo-source');
    if (source) attributes.custom_source = source;
    return fetch(KLAVIYO_ENDPOINT + encodeURIComponent(company), {
      method: 'POST',
      headers: { 'content-type': 'application/vnd.api+json', revision: root.getAttribute('data-klaviyo-revision') },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: attributes,
          relationships: { list: { data: { type: 'list', id: root.getAttribute('data-klaviyo-list') } } }
        }
      })
    }).then(function (response) {
      if (!response.ok) throw new Error('Klaviyo responded ' + response.status);
    });
  }

  /* ---------- Meta "Lead" after a confirmed sign-up ----------
     The Facebook & Instagram app pixel runs sandboxed (no window.fbq), so the base code is
     loaded here on demand: init only, no PageView, so the app's page views aren't doubled. */
  function marketingAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    return !(privacy && typeof privacy.marketingAllowed === 'function' && !privacy.marketingAllowed());
  }

  function loadMetaPixel() {
    if (typeof window.fbq === 'function') return window.fbq;
    var fbq = function () {
      if (fbq.callMethod) fbq.callMethod.apply(fbq, arguments);
      else fbq.queue.push(arguments);
    };
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    window.fbq = fbq;
    if (!window._fbq) window._fbq = fbq;
    var script = document.createElement('script');
    script.async = true;
    script.src = META_PIXEL_SRC;
    document.head.appendChild(script);
    return fbq;
  }

  /* the app pixel usually has it initialised already; a second init only logs a duplicate warning */
  function hasPixel(fbq, pixel) {
    if (typeof fbq.getState !== 'function') return false;
    return fbq.getState().pixels.some(function (p) { return p.id === pixel; });
  }

  function trackLead(root, email) {
    var pixel = root.getAttribute('data-meta-pixel');
    if (!pixel || !marketingAllowed()) return;
    try {
      var fbq = loadMetaPixel();
      if (!metaPixelsReady[pixel] && !hasPixel(fbq, pixel)) {
        fbq('init', pixel, email ? { em: email.toLowerCase() } : {});
      }
      metaPixelsReady[pixel] = true;
      fbq('trackSingle', pixel, 'Lead', { content_name: root.getAttribute('data-meta-lead-name') || 'Colorama' });
    } catch (err) {
      console.error('[colorama] Meta Lead tracking failed', err);
    }
  }

  function wireForm(root, form) {
    var input = form.querySelector('input[type="email"]');
    var button = form.querySelector('[type="submit"]');
    var error = form.querySelector('[data-cl-error]');
    var useKlaviyo = root.hasAttribute('data-klaviyo-list');
    var busy = false;
    if (!input) return;
    function showError(message) {
      input.setAttribute('aria-invalid', 'true');
      if (error) { error.textContent = message; error.hidden = false; }
    }
    function clearError() {
      input.removeAttribute('aria-invalid');
      if (error) { error.hidden = true; error.textContent = ''; }
    }
    function markSent() { form.classList.add('is-sent'); }

    if (form.querySelector('[data-cl-posted]')) { markSent(); trackLead(root); }
    if (form.querySelector('[data-cl-posted-error]')) showError(root.getAttribute('data-msg-error'));

    form.addEventListener('submit', function (event) {
      var email = input.value.trim();
      if (!EMAIL_RE.test(email)) { event.preventDefault(); showError(root.getAttribute('data-msg-invalid')); input.focus(); return; }
      clearError();
      if (!useKlaviyo) return;
      event.preventDefault();
      if (busy) return;
      busy = true;
      if (button) button.disabled = true;
      subscribeToKlaviyo(root, email)
        .then(function () { markSent(); trackLead(root, email); })
        .catch(function (err) {
          console.error('[colorama] Klaviyo subscribe failed', err);
          showError(root.getAttribute('data-msg-error'));
        })
        .then(function () { busy = false; if (button) button.disabled = false; });
    });
    input.addEventListener('input', clearError);
  }

  /* ---------- sign-up popup (falls back to scrolling to the sign-up block) ---------- */
  function scrollToSignup(root) {
    var target = root.querySelector('[data-cl-signup]');
    if (!target) return;
    var y = target.getBoundingClientRect().top + window.scrollY - window.innerHeight * SIGNUP_OFFSET;
    window.scrollTo({ top: y, behavior: RM ? 'auto' : 'smooth' });
  }

  function initModal(root, signal) {
    var modal = root.querySelector('[data-cl-modal]');
    var html = document.documentElement;
    var lastFocus = null;
    function open() {
      if (!modal) { scrollToSignup(root); return; }
      if (modal.open) return;
      lastFocus = document.activeElement;
      modal.classList.remove('is-closing');
      modal.showModal();
      html.style.overflow = 'hidden';
      setTimeout(function () {
        var input = modal.querySelector('input[type="email"]');
        var form = modal.querySelector('.cl-form');
        if (input && !(form && form.classList.contains('is-sent'))) input.focus({ preventScroll: true });
      }, MODAL_FOCUS_DELAY_MS);
    }
    function close(immediate) {
      if (!modal || !modal.open) return;
      modal.classList.add('is-closing');
      setTimeout(function () {
        modal.close();
        modal.classList.remove('is-closing');
        html.style.overflow = '';
        if (lastFocus && lastFocus.isConnected) lastFocus.focus({ preventScroll: true });
      }, RM || immediate === true ? 0 : MODAL_CLOSE_MS);
    }
    $$('[data-cl-open-signup]', root).forEach(function (b) {
      on(b, 'click', function (e) { e.preventDefault(); open(); }, signal);
    });
    if (modal) {
      $$('[data-cl-close]', modal).forEach(function (b) { on(b, 'click', close, signal); });
      on(modal, 'cancel', function (e) { e.preventDefault(); close(); }, signal);
      on(modal, 'click', function (e) { if (e.target === modal) close(); }, signal);
    }
    return { open: open, close: close };
  }

  /* ---------- logo links: smooth scroll back to the top ---------- */
  function initTopLinks(root, signal) {
    $$('[data-cl-top]', root).forEach(function (a) {
      on(a, 'click', function (e) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: RM ? 'auto' : 'smooth' });
      }, signal);
    });
  }

  function init(root) {
    if (!root || states.has(root)) return;
    var controller = new AbortController();
    var signal = controller.signal;
    var modal = initModal(root, signal);
    states.set(root, { controller: controller, modal: modal });

    initProgress(root, signal);
    initReveal(root, signal);
    initParallax(root, signal);
    $$('[data-cl-film][data-cl-playable]', root).forEach(function (slot) { wireFilm(slot, signal); });
    $$('.cl-form', root).forEach(function (form) { wireForm(root, form); });
    initTopLinks(root, signal);

    var relock = function () { lockBaselines(root); };
    fontsReady().then(relock);
    on(window, 'resize', relock, signal);
    on(window, 'load', relock, signal);
    relock();
  }

  function destroy(root) {
    var state = states.get(root);
    if (!state) return;
    state.controller.abort();
    state.modal.close(true);
    states.delete(root);
  }

  function rootsIn(scope) {
    if (!scope || !scope.querySelectorAll) return [];
    return $$('[data-colorama]', scope);
  }

  function toggleModalFromEditor(event, shouldOpen) {
    var dialog = event.target;
    if (!dialog || !dialog.matches || !dialog.matches('[data-cl-modal]')) return;
    var state = states.get(dialog.closest('[data-colorama]'));
    if (!state) return;
    if (shouldOpen) state.modal.open(); else state.modal.close(true);
  }

  window.ColoramaLP = { init: init, destroy: destroy };
  rootsIn(document).forEach(init);
  document.addEventListener('shopify:section:load', function (e) { rootsIn(e.target).forEach(init); });
  document.addEventListener('shopify:section:unload', function (e) { rootsIn(e.target).forEach(destroy); });
  document.addEventListener('shopify:block:select', function (e) { toggleModalFromEditor(e, true); });
  document.addEventListener('shopify:block:deselect', function (e) { toggleModalFromEditor(e, false); });
})();
